import React from 'react';
import { FileEdit, CheckCircle2, Clock3 } from 'lucide-react';

const CONFIG = {
  draft: { label: 'Draft', icon: FileEdit, cls: 'bg-background/85 text-amber-600 dark:text-amber-400 border-amber-500/40' },
  published: { label: 'Published', icon: CheckCircle2, cls: 'bg-background/85 text-primary border-primary/40' },
  past: { label: 'Past', icon: Clock3, cls: 'bg-background/85 text-muted-foreground border-border' },
};

export const EventStatusBadge = ({ status, className = '' }) => {
  const cfg = CONFIG[status] || CONFIG.published;
  const Icon = cfg.icon;
  return (
    <span
      data-testid={`event-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full text-xs font-semibold border backdrop-blur-sm ${cfg.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" /> {cfg.label}
    </span>
  );
};
